import React from 'react';
import LeadDetails from '../components/leads/LeadDetails';

const LeadDetail = () => {
  return <LeadDetails />;
};

export default LeadDetail;